import React from 'react';
import { IGatsbyImageData, getImage, getSrc, getSrcSet } from 'gatsby-plugin-image';
import { DateTime } from 'luxon';
import { ReactComponent as IconCalendarSmall } from 'img/icons/icon-calendar-small.svg';

export type EventCardSmallProps = {
    linkUrl: string;
    /**
     * suggested image size: 233x152
     */
    image?: IGatsbyImageData;
    imageAlt?: string;
    title: string;
    dateTime?: DateTime|string;
};

const EventCardSmall: React.FC<EventCardSmallProps> = ({ linkUrl, image, imageAlt = '', title, dateTime }) => {
    const formattedDate = typeof dateTime === 'string' || typeof dateTime === 'undefined' ? dateTime : dateTime.toFormat("cccc, LLL d '@' h:mm a");

    const imageData = getImage(image || null);
    const imgSrc = imageData ? getSrc(imageData) : '';
    const imgSrcSet = imageData ? getSrcSet(imageData) : '';

    return (
        <a href={linkUrl} className="event-card-small">
            <div className="event-card-small__image">
                {image && <img src={imgSrc} srcSet={imgSrcSet} alt={imageAlt} width={imageData?.width} height={imageData?.height} />}
            </div>
            <div className="event-card-small__info">
                <h3 className="h6 title">{title}</h3>
                <div className="icon-text">
                    <IconCalendarSmall />
                    {formattedDate}
                </div>
            </div>
        </a>
    );
};

export default EventCardSmall;